/**
 * Removes the element at the given index from the array.
 * @param {Array} array - Array from which the element will be removed.
 * @param {Number} index - Array position from which the element will be removed.
 * @return {Array} New array with removed element at index index.
 */
export default function immutableRemoveAtIndex(array, index) {
  return [...array.slice(0, index), ...array.slice(index + 1)];
}
